<template>
  <div>
    <hr>

    <!-- DataTable de Pagos -->
    <DataTable
      :data="pagos"
      :columns="columnasPago"
      idField="idPago"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      :acciones="true"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay pagos registrados."
      @refresh="getDataTodos"
      @edit="row => abrirModalEditar(row.idPago)"
      @delete="row => deletePago(row.idPago)"
    >
      <template #acciones-extra>
        <div class="col-auto">
          <button
            class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            @click="abrirModalCrear"
            :disabled="p_estadoFactura !== 'EMITIDA'"
            title="Registrar Pago"
          >
            <span class="material-icons" style="font-size:16px">add_box</span>
            Registrar Pago
          </button>
        </div>
      </template>
    </DataTable>

    <!-- Total de pagos -->
    <div class="d-flex justify-content-end pe-2 fw-bold mb-3">
      TOTAL: {{ formatMonto(totalPagos) }}
    </div>

    <!-- Modal Pago -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content pago-modal">

          <!-- Header -->
          <div class="modal-header pago-modal__header">
            <h5 class="modal-title pago-modal__title">
              <span class="material-icons" style="font-size:20px;vertical-align:-4px;margin-right:6px">
                {{ btnCrear ? 'add_card' : 'edit' }}
              </span>
              {{ titulo }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>

          <form>
            <div class="modal-body">

              <!-- Banner de saldo (solo en modo Crear) -->
              <div class="pago-saldo-banner" v-if="btnCrear">
                <div class="pago-saldo-item">
                  <span class="pago-saldo-label">Total factura</span>
                  <span class="pago-saldo-value pago-saldo-value--blue">{{ formatMonto(totalFactura) }}</span>
                </div>
                <div class="pago-saldo-divider"></div>
                <div class="pago-saldo-item">
                  <span class="pago-saldo-label">Ya pagado</span>
                  <span class="pago-saldo-value">{{ formatMonto(totalFactura - saldo) }}</span>
                </div>
                <div class="pago-saldo-divider"></div>
                <div class="pago-saldo-item">
                  <span class="pago-saldo-label">Saldo pendiente</span>
                  <span class="pago-saldo-value pago-saldo-value--green">{{ formatMonto(saldo) }}</span>
                </div>
              </div>

              <!-- Barra de progreso (solo en modo Crear) -->
              <div class="pago-progress" v-if="btnCrear">
                <div class="pago-progress__labels">
                  <span>Progreso de pago</span>
                  <span>{{ porcentajePagado }}%</span>
                </div>
                <div class="pago-progress__bar">
                  <div class="pago-progress__fill" :style="{ width: porcentajePagado + '%' }"></div>
                </div>
              </div>

              <!-- Fila: Forma de pago + Fecha -->
              <div class="row mb-3">
                <div class="col-6">
                  <label class="pago-label">Forma de pago</label>
                  <select class="form-control" v-model="datoPago.idFormaPago">
                    <option value="" disabled>Seleccionar...</option>
                    <option v-for="fp in formaPagos" :value="fp.idFormaPago" :key="fp.idFormaPago">
                      {{ fp.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-6">
                  <label class="pago-label">Fecha de pago</label>
                  <input type="date" class="form-control" v-model="datoPago.fechaPago" disabled>
                </div>
              </div>

              <!-- Asegurador (condicional) -->
              <div class="mb-3" v-if="datoPago.idFormaPago == 5">
                <label class="pago-label">Asegurador</label>
                <select class="form-control" v-model="datoPago.idAsegurador">
                  <option value="" disabled>Seleccionar asegurador...</option>
                  <option v-for="a in aseguradors" :value="a.idAsegurador" :key="a.idAsegurador">
                    {{ a.nombre }}
                  </option>
                </select>
              </div>

              <!-- Fila: Monto + Referencia -->
              <div class="row mb-1">
                <div class="col-6">
                  <label class="pago-label">Monto</label>
                  <input
                    type="number"
                    class="form-control"
                    :class="montoClaseInput"
                    v-model.number="datoPago.monto"
                    min="0"
                    step="0.01"
                    required
                  >
                  <!-- Feedback de monto -->
                  <div class="pago-monto-hint" :class="montoHintClase" v-if="btnCrear && datoPago.monto >= 0">
                    <span class="material-icons" style="font-size:14px;vertical-align:-3px">{{ montoHintIcono }}</span>
                    {{ montoHintTexto }}
                  </div>
                </div>
                <div class="col-6">
                  <label class="pago-label">Referencia / Nro. comprobante</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoPago.referencia"
                    style="text-transform:uppercase"
                    placeholder="Ej: TRF-00123"
                  >
                </div>
              </div>

              <!-- Estado Pago (solo en edición) -->
              <div class="mb-3 mt-3" v-if="btnEditar">
                <label class="pago-label">Estado Pago</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="datoPago.estadoPago"
                  style="text-transform:uppercase"
                  required
                >
              </div>

              <!-- Bloque de auditoría colapsable -->
              <div class="mt-3" v-if="1==0">
                <button type="button" class="pago-audit-toggle" @click="mostrarOcultarBloque">
                  <span class="material-icons" style="font-size:15px;transition:transform .2s" :style="mostrarBloque ? 'transform:rotate(90deg)' : ''">
                    chevron_right
                  </span>
                  Datos de auditoría
                </button>

                <div class="pago-audit-block" v-if="mostrarBloque">
                  <div class="row g-2">
                    <div class="col-6" v-if="btnEditar">
                      <label class="pago-audit-label">Id Pago</label>
                      <input type="text" class="form-control form-control-sm" v-model="datoPago.idPago" disabled>
                    </div>
                    <div class="col-6">
                      <label class="pago-audit-label">Id Factura</label>
                      <select class="form-control form-control-sm" v-model="datoPago.idFactura">
                        <option v-for="f in facturas" :value="f.idFactura" :key="f.idFactura">
                          {{ f.nombre }}
                        </option>
                      </select>
                    </div>
                    <div class="col-6">
                      <label class="pago-audit-label">Usuario Reg.</label>
                      <input type="text" class="form-control form-control-sm" v-model="datoPago.idUsuarioReg" disabled>
                    </div>
                    <div class="col-6">
                      <label class="pago-audit-label">Usuario Act.</label>
                      <input type="text" class="form-control form-control-sm" v-model="datoPago.idUsuarioAct" disabled>
                    </div>
                    <div class="col-6">
                      <label class="pago-audit-label">Fecha Reg.</label>
                      <input type="text" class="form-control form-control-sm" v-model="datoPago.fechaReg" disabled>
                    </div>
                    <div class="col-6">
                      <label class="pago-audit-label">Fecha Act.</label>
                      <input type="date" class="form-control form-control-sm" v-model="datoPago.fechaAct">
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </form>

          <!-- Footer -->
          <div class="modal-footer">
            <p class="pago-alerta-saldo me-auto" v-if="saldo === 0 && btnCrear">
              <span class="material-icons" style="font-size:15px;vertical-align:-3px">info</span>
              El pago ya se realizó en su totalidad, no existe saldo pendiente.
            </p>
            <p class="pago-alerta-excede me-auto" v-if="montoExcedeSaldo && btnCrear">
              <span class="material-icons" style="font-size:15px;vertical-align:-3px">warning</span>
              El monto supera el saldo pendiente ({{ formatMonto(saldo) }}).
            </p>

            <button
              type="button"
              class="btn btn-light"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>

            <button
              type="button"
              class="btn btn-primary d-flex align-items-center gap-1"
              @click.prevent="guardarPago"
              v-if="btnCrear"
              :disabled="montoExcedeSaldo || datoPago.monto <= 0"
              title="Guardar"
            >
              <span class="material-icons" style="font-size:18px">save</span>
              Guardar pago
            </button>

            <button
              type="button"
              class="btn btn-primary d-flex align-items-center gap-1"
              @click.prevent="guardarEditPago"
              v-if="btnEditar"
              title="Actualizar"
            >
              <span class="material-icons" style="font-size:18px">update</span>
              Actualizar
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              @click.prevent="guardarEditPagoEstado"
              v-if="btnEditar"
            >
              Listo
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import { currentDate } from '@/modules/dateUtils'
import api from "@/services/api"
import * as $ from 'jquery'
window["$"] = $
window["jQuery"] = $
import swal from 'sweetalert'
import swal2 from 'sweetalert2'

export default {
  components: { DataTable },

  props: {
    p_idFactura:     { type: Number, required: true },
    p_estadoFactura: { type: String, required: true },
  },

  data() {
    return {
      pagos:        [],
      datoPago:     {},
      titulo:       '',
      btnCrear:     false,
      btnEditar:    false,
      modalWindow:  true,
      mostrarBloque: false,
      facturas:     [],
      formaPagos:   [],
      aseguradors:  [],
      saldo:        0,
      totalFactura: 0,

      columnasPago: [
        {
          field: 'fechaPago',
          label: 'Fecha Pago',
          format: (val) => dateFormat.getFormattedDate(val),
        },
        { field: 'formaPagoNombre',  label: 'Forma de Pago' },
        { field: 'aseguradorNombre', label: 'Asegurador' },
//        { field: 'estadoPago',       label: 'Estado Pago' },
        { field: 'monto',            label: 'Monto' },
        { field: 'referencia',       label: 'Referencia' },
      ],
    }
  },

  computed: {
    totalPagos() {
      return this.pagos.reduce((acc, pago) => acc + (pago.monto ?? 0), 0)
    },

    porcentajePagado() {
      if (!this.totalFactura || this.totalFactura === 0) return 0
      const monto = parseFloat(this.datoPago.monto) || 0
      const pagado = this.totalFactura - this.saldo
      return Math.min(100, Math.round(((pagado + monto) / this.totalFactura) * 100))
    },

    montoExcedeSaldo() {
      return parseFloat(this.datoPago.monto) > this.saldo
    },

    montoHintTexto() {
      const monto = parseFloat(this.datoPago.monto) || 0
      if (monto <= 0) return 'Ingresa un monto mayor a 0'
      if (monto > this.saldo) return `Supera el saldo pendiente (${this.formatMonto(this.saldo)})`
      if (monto === this.saldo) return 'Cubre el saldo exacto'
      const restante = this.saldo - monto
      return `Quedará un saldo pendiente de ${this.formatMonto(restante)}`
    },

    montoHintClase() {
      const monto = parseFloat(this.datoPago.monto) || 0
      if (monto <= 0 || monto > this.saldo) return 'pago-monto-hint--warn'
      if (monto === this.saldo) return 'pago-monto-hint--ok'
      return 'pago-monto-hint--info'
    },

    montoHintIcono() {
      const monto = parseFloat(this.datoPago.monto) || 0
      if (monto <= 0 || monto > this.saldo) return 'error_outline'
      if (monto === this.saldo) return 'check_circle_outline'
      return 'info_outline'
    },

    montoClaseInput() {
      if (!this.btnCrear) return ''
      const monto = parseFloat(this.datoPago.monto) || 0
      if (monto > this.saldo) return 'is-invalid'
      if (monto > 0 && monto <= this.saldo) return 'is-valid'
      return ''
    },
  },

  mounted() {
    this.getDataTodos()
    this.fetchFormaPagos()
    this.fetchAseguradors()
  },

  methods: {
    formatMonto(valor) {
      return new Intl.NumberFormat('es-EC', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(valor ?? 0)
    },

    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque
    },

    // Datos
    getDataTodos() {
      api.get('/vwpagos/idfactura/' + this.p_idFactura).then(response => {
        this.pagos = response.data.reverse()
      })
    },

    // Validación
    validarForm() {
      return validarForm(
        this.datoPago,
        ['idFormaPago', 'monto'],
        ['Forma de Pago', 'Monto']
      )
    },

    // Guardar (Crear)
    async guardarPago() {
      if (this.datoPago.monto > this.saldo) {
        swal("Error!", "El valor máximo es " + this.formatMonto(this.saldo), "error"); return
      }
      if (this.datoPago.monto <= 0) {
        swal("Error!", "El valor debe ser mayor a 0.", "error"); return
      }
      if (this.validarForm() !== 1) return

      try {
        this.datoPago.idEmpresa    = window.sessionStorage.getItem("idEmpresa")
        this.datoPago.idUsuarioReg = window.sessionStorage.getItem("idUsuario")
        this.datoPago.idFactura    = this.p_idFactura

        await api.post('/pagos', this.datoPago)
        $('#ventanaModal').modal('hide')

        const saldoRestante = this.saldo - this.datoPago.monto

        if (saldoRestante === 0) {
          swal2.fire({
            title: "Pago completado",
            text: "El pago ha sido registrado. No hay saldo pendiente.",
            icon: "success",
            confirmButtonText: "Aceptar",
          })
        } else {
          swal2.fire({
            title: "Pago registrado con saldo pendiente",
            text: `Aún queda un saldo pendiente de ${this.formatMonto(saldoRestante)}. ¿Deseas registrar otro pago ahora?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Registrar otro pago",
            cancelButtonText: "Más tarde",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
          }).then(result => {
            if (result.isConfirmed) this.abrirModalCrear()
            else swal2.fire({
              title: "Pago postergado",
              text: "Puedes continuar registrando pagos en cualquier momento.",
              icon: "info",
            })
          })
        }

//        this.getDataTodos()
        this.$router.go(0)

      } catch {
        swal2.fire({
          title: "Error en el proceso",
          text: "Ha ocurrido un error al intentar procesar el pago.",
          icon: "error",
        })
      }
    },

    // Guardar (Editar)
    async guardarEditPago() {
      if (this.datoPago.monto > this.saldo) {
        swal("Error!", "El valor máximo es " + this.formatMonto(this.saldo), "error"); return
      }
      if (this.validarForm() !== 1) return

      try {
        this.datoPago.idUsuarioAct = window.sessionStorage.getItem("idUsuarioAct")
        await api.post('/pagos', this.datoPago)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Pago actualizado exitosamente!", "success")
        this.getDataTodos()
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error")
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },

    async guardarEditPagoEstado() {
      if (this.validarForm() !== 1) return

      try {
        this.datoPago.estadoPago = "PENDIENTE"
        await api.post('/pagos', this.datoPago)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Estado actualizado exitosamente!", "success")
        this.getDataTodos()
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error")
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },

    // Modals
    abrirModalCrear() {
      this.titulo      = 'Registrar pago'
      this.btnCrear    = true
      this.btnEditar   = false
      this.mostrarBloque = false

      this.calcularSaldo().then(() => {
        this.datoPago = {
          monto:      this.saldo,
          fechaPago:  currentDate(new Date()),
          idFormaPago: '',
        }
        this.$nextTick(() => $('#ventanaModal').modal('show'))
      })
    },

    abrirModalEditar(idPago) {
      this.titulo      = 'Editar pago'
      this.btnCrear    = false
      this.btnEditar   = true
      this.mostrarBloque = false

      if (idPago) {
        api.get('/vwpagos/' + idPago).then(resp => {
          this.datoPago = resp.data
        })
      }
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },

    async deletePago(idPago) {
      const ok = await swal({
        title: "¿Eliminar pago?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      if (!ok) return

      try {
        await api.delete('/pagos/' + idPago)
        this.getDataTodos()
      } catch {
        swal("Error!", "No se pudo eliminar.", "error")
      }
    },

    // Catálogos
    fetchFormaPagos() {
      api.get('/vwformapagos')
        .then(r => { this.formaPagos = r.data })
        .catch(e => console.error('Error fetching formaPagos:', e))
    },

    fetchAseguradors() {
      api.get('/vwaseguradors')
        .then(r => { this.aseguradors = r.data })
        .catch(e => console.error('Error fetching aseguradors:', e))
    },

    // Saldo — un solo endpoint que devuelve { saldo, totalFactura }
    async calcularSaldo() {
      try {
        const { data } = await api.get(`/vwfacturas/${this.p_idFactura}/saldo`)
        // Si el backend devuelve un objeto { saldo, totalFactura }:
        this.saldo        = data.saldo        ?? data   // compatibilidad si devuelve solo el número
        this.totalFactura = data.totalFactura ?? 0
      } catch (error) {
        console.error('Error calculando el saldo:', error)
      }
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>

<style scoped>
/* ── Header ── */
.pago-modal__header {
  background: #185FA5;
  color: #E6F1FB;
}
.pago-modal__title {
  color: #E6F1FB;
  font-size: 16px;
  font-weight: 500;
}

/* ── Banner de saldo ── */
.pago-saldo-banner {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: .75rem 1rem;
  margin-bottom: 1.1rem;
}
.pago-saldo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}
.pago-saldo-label {
  font-size: 11px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: .04em;
}
.pago-saldo-value {
  font-size: 18px;
  font-weight: 500;
  color: #212529;
}
.pago-saldo-value--blue  { color: #185FA5; }
.pago-saldo-value--green { color: #0F6E56; }
.pago-saldo-divider {
  width: 1px;
  background: #dee2e6;
  height: 36px;
}

/* ── Barra de progreso ── */
.pago-progress {
  margin-bottom: 1.1rem;
}
.pago-progress__labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
}
.pago-progress__bar {
  height: 6px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}
.pago-progress__fill {
  height: 100%;
  background: #185FA5;
  border-radius: 4px;
  transition: width .35s ease;
}

/* ── Labels ── */
.pago-label {
  display: block;
  font-size: 13px;
  color: #495057;
  margin-bottom: 4px;
  font-weight: 500;
}

/* ── Hint debajo del monto ── */
.pago-monto-hint {
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 3px;
}
.pago-monto-hint--ok   { color: #0F6E56; }
.pago-monto-hint--warn { color: #BA7517; }
.pago-monto-hint--info { color: #495057; }

/* ── Auditoría ── */
.pago-audit-toggle {
  background: none;
  border: none;
  padding: 4px 0;
  font-size: 13px;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.pago-audit-toggle:hover { color: #343a40; }

.pago-audit-block {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: .75rem;
  margin-top: .4rem;
}
.pago-audit-label {
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 2px;
  display: block;
}

/* ── Footer alertas ── */
.pago-alerta-saldo {
  color: #0F6E56;
  font-weight: 500;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 0;
}
.pago-alerta-excede {
  color: #BA7517;
  font-weight: 500;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 0;
}
</style>